/* eslint-disable react/prop-types */
import {
  TextField as MuiTextField,
  Box,
  Button,
  Grid,
  IconButton,
  Popover,
  Tooltip,
} from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React from 'react'
import { Formik, Form, Field } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { KeyboardDatePicker } from 'formik-material-ui-pickers'
import { useLocation, useParams } from 'react-router'
import { Autocomplete } from 'formik-material-ui-lab'

import { details, late } from '../HomeActions'

export default function Filter(props) {
  const dispatch = useDispatch()
  const { classes } = props
  const { id } = useParams()
  const location = useLocation()
  const statuses = useSelector(state => state.dashboard.statuses)

  return (
    <Tooltip title="Filter list">
      <PopupState variant="popover" popupId="demo-popup-popover">
        {popupState => (
          <div>
            <IconButton aria-label="filter list" {...bindTrigger(popupState)}>
              <FilterListIcon />
            </IconButton>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box p={2} className={classes.popover}>
                <div className={classes.root}>
                  <Formik
                    initialValues={{
                      status: null,
                      date: null,
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      setSubmitting(false)
                      if (location.pathname.includes('late')) {
                        dispatch(late(values))
                      } else {
                        dispatch(details(id, values))
                      }
                    }}
                  >
                    {({ submitForm, isSubmitting }) => (
                      <Form className={classes.form}>
                        <Grid
                          container
                          className={classes.gridContainer}
                          spacing={1}
                          justify="center"
                          alignItems="center"
                        >
                          <Grid item xs={6}>
                            <Field
                              name="status"
                              component={Autocomplete}
                              options={statuses}
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              getOptionLabel={option =>
                                typeof option === 'string'
                                  ? option
                                  : option.name
                              }
                              renderInput={params => (
                                <MuiTextField
                                  {...params}
                                  label="Status"
                                  margin="dense"
                                  variant="outlined"
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <Field
                              component={KeyboardDatePicker}
                              name="date"
                              clearLabel="Limpar"
                              label="Data da Coleta"
                              margin="dense"
                              openTo="year"
                              fullWidth
                              clearable
                              orientation="landscape"
                              format="dd/MM/yyyy"
                              inputVariant="outlined"
                              autoOk
                            />
                          </Grid>

                          <Grid item xs>
                            <Button
                              color="primary"
                              fullWidth
                              type="submit"
                              variant="contained"
                              className={classes.submit}
                              onClick={popupState.close}
                            >
                              <SearchIcon />
                              {` Filtrar`}
                            </Button>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </div>
              </Box>
            </Popover>
          </div>
        )}
      </PopupState>
    </Tooltip>
  )
}
